import { quickStats, channels, watchFeeds, hotTopics } from '@/mocks/blackliao';

export default function HeroBoard() {
  return (
    <section id="top" className="w-full">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6 pt-5 md:pt-7 pb-6">
        {/* parallel stat cards first screen */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {quickStats.map((s) => (
            <div
              key={s.key}
              className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 flex items-center justify-between hover:bg-background-100 transition-colors"
            >
              <div>
                <div className="flex items-baseline gap-1">
                  <span className="text-2xl md:text-3xl font-black text-primary-600">{s.num}</span>
                  <span className="text-sm font-bold text-foreground-800">{s.unit}</span>
                </div>
                <div className="mt-1.5 text-xs md:text-sm text-foreground-600">{s.label}</div>
              </div>
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-600 text-lg">
                <i className={s.icon}></i>
              </span>
            </div>
          ))}
        </div>

        {/* wide banner with watch feeds + topics */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 md:gap-4 mt-3 md:mt-4">
          <div className="lg:col-span-2 rounded-lg border border-background-200 overflow-hidden relative">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=anonymous%20people%20silhouettes%20gathered%20around%20glowing%20screens%20reading%20live%20news%20feed%20in%20dark%20editorial%20room%2C%20red%20accent%20lighting%2C%20cinematic%20documentary%20style%2C%20high%20contrast%2C%20shallow%20depth%2C%20warm%20and%20cool%20light%20mix%2C%20gossip%20community%20atmosphere&width=1200&height=420&seq=hero-board&orientation=landscape"
                alt="新黑料网热帖围观现场氛围图"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/50 to-foreground-950/20"></div>
            <div className="relative p-5 md:p-8 max-w-xl">
              <span className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-[11px] font-semibold text-background-50 whitespace-nowrap">
                <i className="ri-broadcast-line"></i>新黑料网热帖 · 实时
              </span>
              <h2 className="mt-3 text-xl md:text-2xl font-black leading-snug text-background-50">
                全网热议进行时，围观新一波节奏
              </h2>
              <p className="mt-2 text-sm text-background-100/90 leading-relaxed">
                汇聚新黑料网论坛热门讨论，热帖排行实时刷新，社区评论与爆料补充一站式围观，理性吃瓜不站队。
              </p>
              <div className="mt-4 flex flex-wrap gap-2">
                <a href="#hot" className="inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-primary-500 px-4 h-9 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors">
                  查看热帖排行<i className="ri-arrow-right-line"></i>
                </a>
                <a href="#forum" className="inline-flex whitespace-nowrap items-center gap-1.5 rounded-md border border-background-100/40 px-4 h-9 text-sm font-semibold text-background-50 hover:bg-background-50/10 transition-colors">
                  进入论坛讨论
                </a>
              </div>
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 flex flex-col">
            <div className="flex items-center justify-between">
              <h3 className="text-sm md:text-base font-bold text-foreground-900 flex items-center gap-1.5">
                <i className="ri-fire-line text-primary-500"></i>正在热聊
              </h3>
              <span className="text-[11px] text-foreground-500 whitespace-nowrap">实时热度榜</span>
            </div>
            <div className="mt-3 flex-1 space-y-2">
              {hotTopics.map((t, i) => (
                <a
                  key={t.title}
                  href="#hot"
                  className="flex items-center gap-2 rounded-md px-2 py-2 hover:bg-background-100 transition-colors group"
                >
                  <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded text-[11px] font-bold ${i < 3 ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-foreground-600'}`}>
                    {i + 1}
                  </span>
                  <span className="truncate text-[13px] text-foreground-800 group-hover:text-primary-700">{t.title}</span>
                  <span className="ml-auto shrink-0 text-[10px] text-primary-600 whitespace-nowrap">{t.heat}</span>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* channel quick nav */}
        <div className="mt-4 flex items-center gap-2 overflow-x-auto no-scrollbar rounded-lg border border-background-200 bg-background-50 px-3 py-2.5">
          <span className="flex shrink-0 items-center gap-1 text-xs text-foreground-500 whitespace-nowrap">
            <i className="ri-apps-2-line text-primary-500"></i>分区速览
          </span>
          {channels.map((c) => (
            <a
              key={c.key}
              href="#forum"
              className="shrink-0 rounded-full border border-background-200 bg-background-100 px-3 py-1 text-xs text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors whitespace-nowrap"
            >
              {c.label}
            </a>
          ))}
        </div>

        {/* live watching strip */}
        <div className="mt-3 grid grid-cols-1 sm:grid-cols-3 gap-3">
          {watchFeeds.map((f) => (
            <div key={f.label} className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3">
              <div className="flex flex-col items-center justify-center rounded-md bg-accent-100 text-accent-700 min-w-14 px-2 py-1">
                <span className="text-base font-black leading-none">{f.num}</span>
                <span className="text-[10px] mt-0.5 whitespace-nowrap">{f.label}</span>
              </div>
              <p className="text-xs md:text-sm leading-relaxed text-foreground-700">{f.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}